import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'
import { colorText } from '../../../themeConstants'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    containerStoresFilter: {
        flexDirection: 'row',
        marginHorizontal: 6,
    },
    flatList: {
        flex: 1,
        flexGrow: 1,
        paddingHorizontal: 10,
    },
    containerWelcomeMessage: {
        flex: 1,
        flexDirection: 'col',
        alignItems: 'flex-start',
        margin: 10,
        paddingVertical: 12,
        paddingLeft: 16,
        paddingRight: 6,
        borderRadius: 10,
        borderWidth: 0.2,
        borderColor: theme.colors.mediumGray,
    },
    textTitleWelcomeMessage: {
        flex: 1,
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        marginBottom: 4,
    },
    textDescriptionWelcomeMessage: {
        flex: 1,
        fontSize: 13,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
    },
    containerCloseButton: {
        flex: 1,
        alignItems: 'center',
    },
    textClose: {
        fontSize: 12,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
        paddingTop: 5,
    },
    containerCampaignData: {
        //// tarjeta
        //marginHorizontal: 12,
        //paddingVertical: 16,
        //borderRadius: 15,
        marginBottom: 10,
        paddingTop: 10,
        paddingBottom: 10,
    },
    containerProgress: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        //paddingTop: 5,
        //paddingBottom: 2,
        paddingHorizontal: 12,
    },
    progressBar: {
        borderRadius: 6,
        borderColor: theme.colors.colorPrimary,
        marginVertical: 5,
    },
    containerSection: {
        flexDirection: 'column',
        backgroundColor: theme.colors.formsBackground,
        //paddingHorizontal: 15,
        paddingRight: 40,
        paddingVertical: 20,
        marginTop: 10,
    },
    containerSectionInfo: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignContent: 'center',
        alignItems: 'center',
        verticalAlign: 'middle',
    },
    cardStore: {
        borderColor: theme.colors.lightGray,
        flex: 1,
        justifyContent: 'center',
        borderWidth: 0.5,
        borderRadius: 10,
        marginVertical: 5,
        padding: 10,
        backgroundColor: 'white',
    },
    textDate: {
        fontSize: 20,
        color: theme.colors.textPrimary,
        paddingLeft: 12,
        paddingBottom: 5,
    },
    textCampaign: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        paddingLeft: 10,
        paddingBottom: 15,
    },
    textCampaignDate: {
        fontSize: 15,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
        paddingRight: 10,
        paddingBottom: 15,
        textAlign: 'left',
    },
    textSection: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
    },
    containerData: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: 5,
    },
    containerDailySurvey: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginLeft: 15,
        marginRight: 10,
    },
    containerFormCompleted: {
        flexDirection: 'row',
        alignItems: 'baseline',
        paddingHorizontal: 12,
    },
    containerFormsCompleted: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginHorizontal: 12,
        paddingTop: 16,
    },
    dividerVerticalLine: {
        borderLeftWidth: 1,
        borderLeftColor: theme.colors.lightGray,
        height: '100%',
    },
    linearGradient: {
        flexDirection: 'row',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        marginTop: 12,
        marginHorizontal: 12,
        padding: 12,
        borderWidth: 1,
        borderColor: 'white',
        borderRadius: 20,
    },
    containerFormProgress: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        marginHorizontal: 12,
    },
    formsProgress: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    textPercentage: {
        fontSize: 16,
        fontWeight: 'bold',
        color: 'white',
        paddingRight: 8,
    },
    containerInfoStore: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    statusImage: {
        width: 20,
        height: 20,
        margin: 4,
    },
    storeImage: {
        width: 20,
        height: 20,
        marginRight: 5,
    },
    textNameStore: {
        fontSize: 15,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginVertical: 5,
    },
    textAddressStore: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        marginBottom: 5,
    },
    textAddressStoreWithGoTo: {
        fontSize: 14,
        fontWeight: 'bold',
        color: '#6D85DA',
        marginBottom: 5,
        textDecorationLine: 'underline',
    },
    textCodeStore: {
        fontSize: 12,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
    },
    textDistanceStore: {
        fontSize: 12,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
    },
    textAddressStoreJTI: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginBottom: 5,
    },
    textInfoStore: {
        fontSize: 13,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginBottom: 5,
    },
    containerCampaignHeader: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginLeft: 16,
        marginRight: 12,
    },
    textSurvey: {
        fontSize: 18,
        fontWeight: 'bold',
        color: colorText,
        marginBottom: 2,
        textTransform: 'uppercase',
    },
    textInfoSurvey: {
        fontSize: 14,
        fontWeight: 'normal',
        color: colorText,
        paddingRight: 10,
    },
    textProgressSurvey: {
        fontSize: 14,
        fontWeight: 'bold',
        color: 'white',
        paddingRight: 26,
    },
    containerGoToMap: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: 0,
        paddingRight: 24,
        paddingVertical: 4,
        borderRadius: 5,
        //backgroundColor: theme.colors.colorPrimary,
    },
    textGoToMap: {
        fontSize: 14,
        fontWeight: 'bold',
        color: colorText,
        paddingLeft: 5,
        paddingRight: 5,
    },
    textLastVisit: {
        fontSize: 13,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        marginVertical: 5,
    },
    dividerHorizontalLine: {
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        width: '100%',
        marginVertical: 10,
    },
    statusModuleList: {
        justifyContent: 'center',
        alignContent: 'center',
        marginVertical: 2,
        paddingLeft: 5,
        paddingRight: 8,
        paddingVertical: 5,
        borderRadius: 5,
        alignSelf: 'flex-start',
    },
    statusModuleText: {
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    circleTag: {
        flexDirection: 'row',
        width: 28,
        height: 28,
        borderRadius: 15,
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 10,
    },
    textCircleTag: {
        fontSize: 8,
        textTransform: 'uppercase',
        fontWeight: '900',
        color: 'white',
    },
    textDistance: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        paddingLeft: 5,
    },
    containerCampaignProgress: {
        flexDirection: 'row',
        height: 10,
        borderRadius: 6,
        overflow: 'hidden',
        backgroundColor: 'white',
    },
    compaignProgress: {
        width: 50,
        backgroundColor: theme.colors.colorTertiary,
    },
    containerReferences: {
        flexDirection: 'row',
        alignItems: 'center',
        alignContent: 'center',
        marginBottom: 5,
        marginHorizontal: 15,
    },
    circlesReferences: {
        width: 12,
        height: 12,
        borderRadius: 6,
    },
    textReferences: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        paddingLeft: 5,
        paddingRight: 10,
        textAlign: 'left',
    },
    textForm: {
        fontSize: 12,
        fontWeight: 'bold',
        color: colorText,
        paddingRight: 8,
        paddingTop: 1,
    },
    textFormDate: {
        fontSize: 10,
        fontWeight: 'normal',
        color: 'white',
    },
    formButton: {
        flexDirection: 'row',

        marginTop: 15,
        marginHorizontal: 12,
        backgroundColor: 'white',
        borderWidth: 1.5,
        borderColor: 'white',
        padding: 5,
        borderRadius: 20,
        alignItems: 'center',
        justifyContent: 'center',
    },
    containerAlert: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',

        flex: 1,
    },
    alertImage: {
        width: 20,
        height: 20,
        aspectRatio: 1,
    },
    mainButtonText: {
        fontSize: 15,
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    mainButtonTextBis: {
        fontSize: 15,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
        paddingLeft: 5,
    },
    activity: {
        fontSize: 15,
        paddingLeft: 4,
        color: 'white',
        textAlign: 'left',
        fontWeight: 'normal',
        maxWidth: '85%',
    },
    offRoute: {
        fontSize: 15,
        paddingLeft: 12,
        color: 'white',
        textAlign: 'left',
        fontWeight: 'normal',
    },
    showMore: {
        fontSize: 15,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
        paddingLeft: 10,
        paddingBottom: 15,
    },
    blockedView: {
        flex: 1,
        opacity: 0.5,
    },
    overlay: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    containerIconButtons: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'white',
        paddingRight: 6,
    },
    iconButton: {
        padding: 6,
    },
    containerNoProducts: {
        flex: 1,
        backgroundColor: 'white',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
    },
    containerNoProductsBis: {
        flex: 1,
        backgroundColor: 'white',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        marginTop: 48,
    },
    image: {
        width: 120,
        height: 120,
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 40,
    },
    description: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 40,
    },
    scrollView: {
        flexDirection: 'row',
        flexGrow: 0,
    },
    buttonCheck: {
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
        marginTop: 0,
    },
    containerStoreClose: {
        flexDirection: 'row',
        alignItems: 'center',
        alignContent: 'center',
        marginHorizontal: 12,
        marginTop: 10,
    },
    flexDirectionRow: { flexDirection: 'row', alignItems: 'center' },
    bold: { fontWeight: 'bold' },
    normal: { fontWeight: 'normal' },
    maxWidth: { maxWidth: '80%' },
    marginLeft: { marginLeft: 8 },
    marginRight: { marginRight: 4 },
    marginLeftBis: { marginLeft: 12 },
    marginRightBis: { marginRight: 60 },
    marginHorizontal: { marginHorizontal: 12 },
    paddingLeft: { paddingLeft: 10 },
    paddingTop: { paddingTop: 4 },
    paddingBottom: { paddingBottom: 5 },
    spacer1: { height: 4 },
    spacer2: { height: 8 },
    spacer3: { height: 12 },
})

export default styles
